// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5584) return "static/chunks/5584-a13dec5eea1f4e2e.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 888 ? "98e2d21d" : chunkId) + "." + {"888":"4cb27e52c316fa86","6881":"52164f7b5da162f0","7324":"c50dff6c2fd061ca"}[chunkId] + ".js";
};